module.exports = __webpack_public_path__ + "static/media/4931-02.ae223072.png";